module.exports = __webpack_public_path__ + "static/media/SalesIcon.b34e250f.png";